export default __webpack_public_path__ + "c5812c2561185403cc2c7e59a69281d0.svg";